<ion-searchbar
    id="searchbar-input"
    class="item-outline"
    debounce="0"
    (keyup.enter)="onSubmitSearch()"
    [(ngModel)]="query"
    [placeholder]="searchPlaceholder"
    (ionInput)="search()"
    (ionClear)="onClearSearch()"
    [disabled]="mapLoaded === false">
</ion-searchbar>
<ion-list
    class="address-search-results"
    aria-relevant="additions"
    aria-live="assertive"
    aria-atomic="true">
    <ion-item
        *ngFor="let result of searchResults"
        button
        lines="none"
        class="item-outline"
        [attr.aria-label]="result.structured_formatting.main_text"
        (touchstart)="hideKeyboard()"
        (click)="selectResult(result)">
        <ion-label aria-hidden="true">
            <h3 role="none">{{ result.structured_formatting.main_text }}</h3>
            <p class="address-search-result-secondary-text">{{ result.structured_formatting.secondary_text }}</p>
        </ion-label>
    </ion-item>
</ion-list>
